import { Controller } from "@hotwired/stimulus"

// Toggles an evaluation choice via AJAX and refreshes the affected table cell.
// Shared by participants/congresses/sections and final_sections.
export default class extends Controller {
  connect() {
    window.initDataTables(".data-tables")
  }

  toggle(event) {
    // Clicking the <label> also fires a synthetic click on its nested radio
    // <input>, which bubbles back through the label and re-triggers this
    // same action. Only handle the click that targets the label itself.
    if (event.target !== event.currentTarget) return

    const button = event.currentTarget
    const msgPlace = $(`#msg-place-${button.dataset.evalPart}`)
    const cell = $(button).closest("td")

    $.ajax({
      method: button.dataset.evalMethod,
      url: button.dataset.evalPath,
      dataType: "json",
      success: (data) => {
        if (data.errors) {
          window.showFlashMessage("danger", data.errors, 2000, msgPlace)
        } else {
          $(data.row).toggleClass("eval-row")
          window.showFlashMessage("info", data.msg, 1000, msgPlace)
        }
        $(".sum-place").html(data.sums)
        cell.html(data.cell)
        cell.closest('tr').find('td').last().find('span[class^="eval-count-"]').html(cell.find('div.btn-group-toggle').data('eval-counts'));
      }
    })
  }
}
